import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type WarrantyRegistrationRewardsFlatTeamSettingGroupId =
  "warranty_registration_rewards.discount";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  path: "settings.warranties",
  product: "returns",
};

const groupRisk: SettingRisk = {
  level: "medium",
  reason:
    "The registration reward discount is a customer-facing incentive that offers money off to customers who register products for warranty coverage.",
};

export const WarrantyRegistrationRewardsFlatTeamSettingGroups = [
  {
    id: "warranty_registration_rewards.discount",
    title: "Registration rewards",
    description:
      "The discount offered as a reward to customers who register products for warranty coverage.",
    productArea: "returns",
    access: directMerchantAccess(SettingsPermissions.SET_WARRANTY_SETTINGS),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: { type: "settings", path: "registration-rewards" },
    synonyms: [
      "registration rewards",
      "registration reward discount",
      "warranty registration reward",
    ],
  },
] as const satisfies readonly SettingGroupDefinition<WarrantyRegistrationRewardsFlatTeamSettingGroupId>[];

type _assertAllWarrantyRegistrationRewardsFlatTeamSettingGroupIdsProvided =
  WarrantyRegistrationRewardsFlatTeamSettingGroupId extends (typeof WarrantyRegistrationRewardsFlatTeamSettingGroups)[number]["id"]
    ? true
    : never;
const _allWarrantyRegistrationRewardsFlatTeamSettingGroupIdsProvided: _assertAllWarrantyRegistrationRewardsFlatTeamSettingGroupIdsProvided = true;
void _allWarrantyRegistrationRewardsFlatTeamSettingGroupIdsProvided;

// The assertion supplies the specific key set that Object.fromEntries cannot
// express in its return type; the assert above keeps the array exhaustive.
export const WarrantyRegistrationRewardsFlatTeamSettingGroupById =
  Object.fromEntries(
    WarrantyRegistrationRewardsFlatTeamSettingGroups.map(
      (
        group,
      ): [
        WarrantyRegistrationRewardsFlatTeamSettingGroupId,
        SettingGroupDefinition<WarrantyRegistrationRewardsFlatTeamSettingGroupId>,
      ] => [group.id, group],
    ),
  ) as Record<
    WarrantyRegistrationRewardsFlatTeamSettingGroupId,
    SettingGroupDefinition<WarrantyRegistrationRewardsFlatTeamSettingGroupId>
  >;
